import { Placement, autoUpdate, flip, offset, shift, size, useFloating } from '@floating-ui/react';
import { FC, ReactNode, useState } from 'react';
import ReactDOM from 'react-dom';



type TooltipPlacement =
    | 'top'
    | 'bottom'
    | 'left'
    | 'right';

type TooltipProps = {
    content: ReactNode;
    children: ReactNode;
    placement?: TooltipPlacement;
};



const Tooltip: FC<TooltipProps> = ({ content, children, placement = 'top' }) => {
    const [visible, setVisible] = useState(false);
    const [hovered, setHovered] = useState(false);
    const { x, y, refs, strategy } = useFloating({
        placement: placement as Placement,
        middleware: [
            offset(0),
            flip(),
            shift({ padding: 0 }),
            size({
                apply({ availableHeight, elements }) {
                    if (elements.floating) {
                        elements.floating.style.maxHeight = availableHeight - 12 + 'px';
                    }
                },
                padding: 8,
            }),
        ],
        whileElementsMounted: autoUpdate,
    });
    // Affiche le tooltip si la souris est sur le trigger ou le tooltip
    const showTooltip = visible || hovered;

    return (
        <div
            ref={refs.setReference}
            style={{ position: 'relative', display: 'inline-block' }}
            onMouseEnter={() => setVisible(true)}
            onMouseLeave={() => setVisible(false)}
        >
            {children}
            {showTooltip && content && ReactDOM.createPortal(
                <div
                    ref={refs.setFloating}
                    style={{
                        position: strategy,
                        top: y ?? 0,
                        left: x ?? 0,
                        background: 'var(--surface-elevated)',
                        color: 'var(--text-primary)',
                        border: '1px solid var(--border-subtle)',
                        padding: '6px 12px',
                        borderRadius: '6px',
                        boxShadow: '0 2px 8px var(--shadow-color)',
                        zIndex: 9999,
                        fontSize: '14px',
                        pointerEvents: 'auto',
                        wordWrap: 'break-word',
                        whiteSpace: 'normal',
                        overflowWrap: 'break-word',
                        maxWidth: '260px',
                        maxHeight: '90vh',
                        overflowY: 'auto',
                    }}
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                >
                    {content}
                </div>,
                document.body
            )}
        </div>
    );
};

export default Tooltip;